import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ShieldIcon from '@mui/icons-material/ShieldOutlined';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

const getServiceIcon = ({service}) => {
  let _Icon = null;
  switch (service) {
    case 'PHYSICAL_THERAPY':
      _Icon = MedicalServicesIcon;
      break;
    case 'FITNESS':
      _Icon = FitnessCenterIcon;
      break;
    case 'SPORTS_PERFORMANCE':
      _Icon = SportsFootballIcon;
      break;
    case 'NUTRITION':
      _Icon = RestaurantIcon;
      break;
    case 'WELLNESS':
      _Icon = SelfImprovementIcon;
      break;
    case 'FREE_EVAL':
      _Icon = ShieldIcon;
      break;
    case 'THIRTY_FOR_THIRTY':
      _Icon = TimerOutlinedIcon;
      break;
    case 'CHIROPRACTIC_REHAB':
      _Icon = MedicalServicesIcon;
      break;
    default:
      _Icon = MedicalServicesIcon;
  }
  return _Icon;
};

export default getServiceIcon;